<template>

    <b-modal id="prevailing-wage-modal" ref="apprenticeRatioRef" v-model="show" centered
        modal-class="a4-portrait no-header no-footer">
        <div class="p-1 overflow-auto h-100 p-relative">
            <div class="floating-header">
                <a href="#" class="bg-white d-block px-2 py-1 text-orange">Download PDF</a>
                <a href="#" class="bg-white d-block px-2 py-1 ml-1 text-orange" @click="show = false">
                    <i class="fa fa-times" />
                </a>
            </div>
            <div class="d-flex align-items-center p-3 justify-content-start">
                <h5 class="text-nowrap">Prevailing Wage Report</h5>
                <b-select v-model="selected_week" :options="week_options" class="ml-4 flex-shrink-1 w-auto"></b-select>
            </div>
            <h6 class="px-3">Wage Determination Location: Houston, Texas</h6>

            <div class="table-responsive p-3">
                <table class="table">
                    <tr class="text-primary">
                        <td>Labor Type</td>
                        <td>Rate</td>
                        <td>Fringes</td>
                        <td>Aggregate Project Wage as Reported</td>
                        <td>Aggregate Fringes</td>
                        <td>Workers Below Prevailing Wage</td>
                        <td></td>
                    </tr>
                    <tr v-for="(labor_type, index) in labor_types" :key="index" class="border-bottom">
                        <td class="bg-light">{{ labor_type.label }}</td>
                        <td class="bg-light">$ {{ labor_type.rate.toFixed(2) }}</td>
                        <td class="bg-light">$ {{ labor_type.fringes }}</td>
                        <td>$ {{ (labor_type.rate + (Math.random() < 0.2 ? 0 : faker.datatype.float({min: 0, max: 0.25, precision: 0.01}))).toFixed(2) }}</td>
                        <td>$ 0</td>
                        <td>{{ labor_type.n_below }}</td>
                        <td>
                            <span v-if="labor_type.n_below"><button class="btn btn-secondary btn-sm">REMEDIATE</button></span>
                        </td>
                    </tr>
                </table>
            </div>

        </div>
    </b-modal>
</template>
<script>
import { mapState } from 'vuex';
import faker from 'faker';

export default {
    name: 'PrevailingWage',
    computed: {
        ...mapState(['workers', 'companies']),
        apprentice_rates() {
            return this.$store.state.report.apprentice_rates;
        },
        weekly_apprentice_rates() {
            const weekly_rates = [];
            const chunks = this.$finder.chunk(Object.keys(this.apprentice_rates), 14);
            for (let week_index in chunks) {
                const dates = chunks[week_index];
                weekly_rates[week_index] = {};
                for (let date of dates) {
                    weekly_rates[week_index][date] = this.apprentice_rates[date];
                }

            }

            return weekly_rates;
        },
        week_options() {
            return this.weekly_apprentice_rates.map((rate, index) => {
                const key = `${Object.keys(rate)[0]} - ${Object.keys(rate)[6]}`;
                return { value: index, text: key }
            });
        },
    },
    data() {
        return {
            selected_week: "0",
            faker: faker,
            show: false,
            labor_types: this.get_labor_types(),
        }
    },
    watch: {
        selected_week() {
            this.labor_types = this.get_labor_types();
        }
    },
    methods: {
        get_labor_types() {
            return [
                { label: "Cement Mason", rate: 23, fringes: 0, n_below: Math.random() < 0.7 ? 0 : faker.datatype.number({min: 1, max: 5}) },
                { label: "General Laborers", rate: 8.75, fringes: 0, n_below: Math.random() < 0.7 ? 0 : faker.datatype.number({min: 1, max: 5}) },
                { label: "Laborer: Pipelayer", rate: 11.25, fringes: 0, n_below: Math.random() < 0.7 ? 0 : faker.datatype.number({min: 1, max: 5}) },
                { label: "Operator: Backhoe", rate: 15.89, fringes: 0, n_below: Math.random() < 0.7 ? 0 : faker.datatype.number({min: 1, max: 5}) },
                { label: "Operator: Bulldozer", rate: 14.25, fringes: 0, n_below: Math.random() < 0.7 ? 0 : faker.datatype.number({min: 1, max: 5}) },
                { label: "Truck Driver", rate: 11.75, fringes: 0, n_below: Math.random() < 0.7 ? 0 : faker.datatype.number({min: 1, max: 5}) },
            ]
        },
    }
}
</script>